import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAsyncThunk } from '@reduxjs/toolkit';
import { trigger as clientCallback } from '../../lib/clientCallback';
import { ErrorCodes, signup, SsoProviders, ssoSignup, StudentType, TokenType, UserType, PxError, listen, removeListener } from '@chegg/one-auth-sdk';
import { isCredentialsValid } from '../helpers';
import { notificationsRioEvent, signupSuccessRioEvent } from '../../lib/rio/rioEvents';
import { EventTypes, recordEvents } from '../../utils/newRelicEvents';
import { getRioClient } from '../../lib/rio/rio';
import { initiatePx } from '../../utils/pxUtils';
import { PxCaptchaTypes } from '../types';
import { validateDomain } from '../../utils/domainSpellingUtils';
import { getTexts } from '../../lib/contentful/defaultTexts';
import { setMfa } from '../sharedActions';
export var sdkSignupReducers = {
  rejected: function rejected(state, action) {
    var _action$type;
    var error = action.payload;
    var email = state.signup.credentials.email;
    var isSso = ((_action$type = action.type) === null || _action$type === void 0 ? void 0 : _action$type.indexOf("Sso")) > -1;
    var clientId = state.clientId;
    var ssoProvider = state.sso.authProvider;
    var authType = isSso ? ssoProvider : 'email/password';
    state.signup.loading = error instanceof PxError;
    sendNotificationsRioEvent(error.code);
    sendNewRelicErrorEvent(error, isSso, clientId, authType);
    switch (error.code) {
      case ErrorCodes.user_already_exists:
        {
          email.valid = false;
          email.error = getTexts().signup.emailRegisteredError;
          state.signup.showUserInfo = false;
          state.signup.credentials.error = '';
          return;
        }
      case ErrorCodes.invalid_email:
        {
          email.valid = false;
          state.signup.showUserInfo = false;
          if (!validateDomain(email.value)) {
            state.signup.credentials.error = getTexts().login.emailError;
          }
          return;
        }
      case ErrorCodes.user_already_exists_migrated:
        {
          email.valid = false;
          state.signup.showUserInfo = false;
          state.signup.credentials.email.error = getTexts().signup.userExistsInMigrationClientError;
          return;
        }
    }
    if (!(error instanceof PxError)) {
      state.signup.showUserInfo = false;
      state.signup.credentials.error = getTexts().signup.genericError;
    }
    return;
  },
  fulfilled: function fulfilled(state) {
    state.signup.loading = false;
    var email = state.signup.credentials.email;
    email.valid = true;
    email.error = '';
    state.signup.credentials.error = '';
    state.signup.showUserInfo = state.signup.showUserInfo || isCredentialsValid(state.signup);
  },
  pending: function pending(state) {
    state.signup.loading = true;
  }
};
export var sdkSignup = createAsyncThunk('oneauth/sdkSignup', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, _ref) {
    var _getRioClient$stateMa;
    var getState, dispatch, rejectWithValue, state, env, isGdpr, clientId, _state$signup, isSso, _state$signup$userInf, userType, _state$signup$userInf2, studentType, hsGradYear, _state$signup$userInf3, yearInCollege, campusId, promos, studentDetails, profile, _getProfileSourceData, sourcePage, sourceProduct, onSignupSuccessEvent, action, authType;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          onSignupSuccessEvent = function _onSignupSuccessEvent(payload) {
            var encryptedEmail = payload.encryptedEmail,
              encryptedCheggId = payload.encryptedCheggId;
            var eventType = isSso && EventTypes.ssoSignUpSuccess || EventTypes.signupSuccess;
            var authType = isSso && state.sso.authProvider || 'email/password';
            var sourcePage = profile.sourcePage ? profile.sourcePage : '';
            var sourceProduct = profile.sourceProduct ? profile.sourceProduct : '';
            signupSuccessRioEvent(state, sourcePage, sourceProduct, encryptedEmail, encryptedCheggId);
            recordEvents(_defineProperty({}, eventType, {
              clientId: clientId,
              authType: authType
            }));
          };
          getState = _ref.getState, dispatch = _ref.dispatch, rejectWithValue = _ref.rejectWithValue;
          state = getState();
          env = state.env, isGdpr = state.isGdpr, clientId = state.clientId, _state$signup = state.signup, isSso = _state$signup.isSso, _state$signup$userInf = _state$signup.userInfo, userType = _state$signup$userInf.userType, _state$signup$userInf2 = _state$signup$userInf.student, studentType = _state$signup$userInf2.studentType, hsGradYear = _state$signup$userInf2.highschool.hsGradYear, _state$signup$userInf3 = _state$signup$userInf2.college, yearInCollege = _state$signup$userInf3.yearInCollege, campusId = _state$signup$userInf3.campusId, promos = _state$signup.gdpr.promos;
          studentDetails = {
            studentType: studentType
          };
          profile = {
            promos: promos ? '1' : isGdpr ? '0' : undefined,
            userType: userType,
            sourceProduct: '',
            sourcePage: ''
          };
          if (!(userType === UserType.student)) {
            _context.next = 15;
            break;
          }
          _context.t0 = studentType;
          _context.next = _context.t0 === StudentType.highschool ? 10 : _context.t0 === StudentType.college ? 13 : 15;
          break;
        case 10:
          studentDetails.highSchoolDetails = {
            hsGradYear: hsGradYear
          };
          profile.studentDetails = studentDetails;
          return _context.abrupt("break", 15);
        case 13:
          studentDetails.collegeDetails = {
            yearInCollege: yearInCollege,
            campusId: campusId
          };
          profile.studentDetails = studentDetails;
        case 15:
          _getProfileSourceData = getProfileSourceData(((_getRioClient$stateMa = getRioClient().stateManager._state) === null || _getRioClient$stateMa === void 0 ? void 0 : _getRioClient$stateMa.viewPrevious) || null), sourcePage = _getProfileSourceData.sourcePage, sourceProduct = _getProfileSourceData.sourceProduct;
          profile.sourcePage = sourcePage;
          profile.sourceProduct = sourceProduct + clientId;
          _context.prev = 18;
          listen('signup.success', onSignupSuccessEvent);
          action = isSso ? sdkSsoSignup : normalSignup;
          _context.next = 23;
          return action(state, profile, clientId);
        case 23:
          _context.next = 37;
          break;
        case 25:
          _context.prev = 25;
          _context.t1 = _context["catch"](18);
          removeListener('signup.success', onSignupSuccessEvent);
          authType = isSso ? state.sso.authProvider : 'email/password';
          if (!(_context.t1.code && _context.t1.code === 'mfa_required')) {
            _context.next = 34;
            break;
          }
          onSignupSuccessEvent({}); // if signup returned mfa_required, it means signup was successful
          dispatch(setMfa({
            isSso: isSso,
            showMfa: true,
            codeValidationError: '',
            mfaPayload: _context.t1.mfaPayload,
            authProvider: state.sso.authProvider || ''
          }));
          recordEvents(_defineProperty({}, EventTypes.mfaRequired, {
            clientId: clientId,
            authType: authType,
            error: _context.t1.message
          }));
          return _context.abrupt("return");
        case 34:
          clientCallback({
            type: 'auth',
            payload: {
              action: 'signup',
              status: 'error',
              errors: _context.t1,
              data: {}
            }
          });
          if (_context.t1 instanceof PxError) {
            initiatePx(env, _context.t1, dispatch, clientId, PxCaptchaTypes.SIGNUP, authType, false, function () {
              dispatch(sdkSignup());
            });
          }
          return _context.abrupt("return", rejectWithValue(_context.t1));
        case 37:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[18, 25]]);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
function normalSignup(state, profile, clientId) {
  var _state$signup$credent = state.signup.credentials,
    email = _state$signup$credent.email.value,
    password = _state$signup$credent.password.value;
  recordEvents(_defineProperty({}, EventTypes.signupSent, {
    clientId: clientId,
    authType: 'email/password'
  }));
  var credentials = {
    email: email,
    password: password
  };
  return signup(credentials, profile, clientId);
}
function sdkSsoSignup(state, profile, clientId) {
  var _state$sso = state.sso,
    email = _state$sso.email,
    authProvider = _state$sso.authProvider,
    authProviderToken = _state$sso.authProviderToken,
    firstName = _state$sso.firstName,
    lastName = _state$sso.lastName;
  recordEvents(_defineProperty({}, EventTypes.ssoSignupSent, {
    clientId: clientId,
    authType: authProvider
  }));
  var creds = {
    email: email,
    provider: getSsoProvider(authProvider),
    providerToken: authProviderToken,
    tokenType: TokenType.accessToken
  };
  var details = {
    email: email
  };
  if (authProvider === 'apple') {
    details.firstName = firstName;
    details.lastName = lastName;
  }
  return ssoSignup(creds, details, profile, clientId);
}
function getSsoProvider(provider) {
  //@ts-ignore
  return SsoProviders[provider];
}
function sendNotificationsRioEvent(errorCode) {
  var message_detail = getTexts().signup.genericError;
  var message_id = 'sign up sdk: genericError';
  switch (errorCode) {
    case ErrorCodes.user_already_exists:
      {
        message_detail = getTexts().signup.emailRegisteredError;
        message_id = "sign up sdk: ".concat(ErrorCodes.user_already_exists);
        break;
      }
    case ErrorCodes.user_already_exists_migrated:
      {
        message_detail = getTexts().signup.userExistsInMigrationClientError;
        message_id = "sign up sdk: ".concat(ErrorCodes.user_already_exists_migrated);
        break;
      }
  }
  notificationsRioEvent({
    notifications: {
      message_id: message_id,
      type: 'error',
      message_detail: message_detail,
      message_name: 'sign up error'
    }
  });
}
function sendNewRelicErrorEvent(error, isSso, clientId, authType) {
  var errorEventType = isSso ? EventTypes.ssoSignupFail : EventTypes.signupFail;
  if (error.code in ErrorCodes) {
    recordEvents(_defineProperty({}, errorEventType, {
      clientId: clientId,
      authType: authType,
      error: error.message,
      isCriticalError: error.criticalError
    }));
  } else {
    recordEvents(_defineProperty({}, EventTypes.signupServerError, {
      error: error.message,
      clientId: clientId,
      authType: authType,
      isCriticalError: error.criticalError
    }));
  }
}
function getProfileSourceData(previousView) {
  var sourcePage = '';
  var sourceProduct = '';
  if (!previousView) {
    return {
      sourcePage: sourcePage,
      sourceProduct: sourceProduct
    };
  }
  if (previousView !== null && previousView !== void 0 && previousView.property) {
    sourcePage += "".concat(previousView.property, "|");
  }
  if (previousView !== null && previousView !== void 0 && previousView.experience) {
    sourceProduct += "".concat(previousView.experience, "|");
  }
  if (previousView !== null && previousView !== void 0 && previousView.feature) {
    sourcePage += "".concat(previousView.feature, "|");
    sourceProduct += "".concat(previousView.feature, "|");
  }
  if (previousView !== null && previousView !== void 0 && previousView.view_name) {
    sourcePage += "".concat(previousView.view_name);
  } else if (document.referrer) {
    sourcePage += "".concat(document.referrer);
  } else {
    sourcePage += "".concat(location.href);
  }
  return {
    sourcePage: sourcePage,
    sourceProduct: sourceProduct
  };
}